import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from './Button'

interface ErrorStateProps {
  message: string
  actionText?: string
  onAction?: () => void
  icon?: ReactNode
  className?: string
}

export function ErrorState({
  message,
  actionText,
  onAction,
  icon,
  className
}: ErrorStateProps) {
  const { t } = useTranslation()
  const resolvedActionText = actionText ?? t('common.retry')
  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className || ''}`}>
      {icon || (
        <svg 
          className="w-16 h-16 text-gray-400 mb-4" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={1.5} 
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" 
          />
        </svg>
      )}
      
      <h3 className="text-lg font-semibold text-gray-900 mb-2">
        {t('errors.unknown_error')}
      </h3>
      
      <p className="text-gray-600 mb-6 max-w-md">
        {message}
      </p>
      
      {onAction && (
        <Button
          onClick={onAction}
          variant="primary"
        >
          {resolvedActionText}
        </Button>
      )}
    </div>
  )
}